import script from "./MediaGallerySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGallerySetup.vue?vue&type=script&setup=true&lang=js"

import "./MediaGallerySetup.vue?vue&type=style&index=0&id=34000198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34000198"]])

export default __exports__